import React from 'react';
import { withLastLocation } from "react-router-last-location";

import facebookIcon from '../../../../../src/assets/img/footerIcons/fb-white.png';
import instaIcon from '../../../../assets/img/footerIcons/ig-white.png';
import linkedinIcon from '../../../../assets/img/footerIcons/IN-white.png';
import twitterIcon from '../../../../assets/img/footerIcons/tw-white.png';
import youtubeIcon from '../../../../assets/img/footerIcons/YT-white.png';
import { getUserLocale, replaceTokensInStrings } from "../../../../helpers/helper";
import { DASHBOARD_FAQS_PATH, DASHBOARD_SETTINGS_PATH } from "../../../../constants/paths";
import { trackEvent } from '../../../../helpers/analyticsHelper';
import { PAGE_EVENT_NAMES, WIDGETS } from '../../../../constants/common';
import { isEmbedMode } from '../../../../helpers/authHelper';

const iconsMapping = {
  facebook: facebookIcon,
  instagram: instaIcon,
  linkedin: linkedinIcon,
  twitter: twitterIcon,
  youtube: youtubeIcon
};

function FooterMain(props) {
  const userLocale = getUserLocale(props.configs.data);
  const isEmbed = isEmbedMode();
  const translations = props.translations.data;
  let socialMediaIcons = props.configs && props.configs.data ? JSON.parse(props.configs.data["social-media-links"]) : [];
  const displayIcons = socialMediaIcons.map((socialMedia, index) => {
    return (
      <a href={socialMedia.link} className="utility-social-media-icon" target="_blank" key={index} data-widget-name={WIDGETS.FOOTER} data-bg-color="color_4" data-text-color="color_54">
        <img src={iconsMapping[socialMedia.name]} alt={index} className={socialMedia.name}></img>
      </a>
    )
  });

  const getPrivacyNote = (note) => {
    let tokenMappings = [
      { key: "{faqsLink}", value: DASHBOARD_FAQS_PATH },
      { key: "{className}", value: "link" },
      { key: "{privacyLink}", value: props.configs.data ? props.configs.data["privacyLink_" + userLocale] : "#" },
      { key: "{privacyNoticeLink}", value: props.configs.data ? props.configs.data["privacyNoticeLink_" + userLocale] : "#" },
      { key: "{unsubscribeLink}", value: DASHBOARD_SETTINGS_PATH + "?tab-type=alertType" }
    ];
    note = replaceTokensInStrings(note, tokenMappings);
    return note;
  };
  const footerCss = props.configs.data["footer.footer_css_container_class"];
  let addressLine1 = translations["UTILITY_INFO.ADDRESS_LINE1"];

  const updateTokenInStrings = (stringValue) => {
    let tokenMappings = [
      { key: "{year}", value: new Date().getFullYear()},
      { key: "{uuid}", value: props.uuid }
    ];
    stringValue = replaceTokensInStrings(stringValue, tokenMappings);
    return stringValue;
  };

  const handleClick = (linkName) => {
    trackEvent(props.uuid, PAGE_EVENT_NAMES.PREFERENCE, {
      clicked: linkName,
    }, props);
  };

  return (
    <>
      { isEmbed ? '' :
        <div className="utility-footer" data-widget-name={WIDGETS.FOOTER} data-bg-color="color_7">
          <div className={`${footerCss} utility-footer-container` } >
            <div className="utility-social-media-icons">
              {displayIcons}
            </div>
            <div className="utility-name">
            <span data-widget-name={WIDGETS.FOOTER} data-text-color="color_4">{translations["UTILITY_INFO.NAME"]}</span>
            </div>
            {
              props.footerNote ?
                (<div className="privacy-note">
                  <span dangerouslySetInnerHTML={{ __html: getPrivacyNote(props.footerNote) }}></span>
                  <br />
                </div>
                ) : ''
            }
            <span className="utility-address">
              <span dangerouslySetInnerHTML={{ __html: updateTokenInStrings(addressLine1) }}></span>
              {translations["UTILITY_INFO.ADDRESS_LINE2"] ?
                (
                  <span data-widget-name={WIDGETS.FOOTER} data-text-color="color_4">
                    <br />
                    {translations["UTILITY_INFO.ADDRESS_LINE2"]}
                  </span>
                )
                : ''
              }
              {translations["UTILITY_INFO.ADDRESS_ZIPCODE"] ?
                (
                  <span data-widget-name={WIDGETS.FOOTER} data-text-color="color_4">
                    <br />
                    {translations["UTILITY_INFO.ADDRESS_ZIPCODE"]}
                  </span>
                )
                : ''
              }
            </span>
            {
              translations["COPY_RIGHT_NOTE"] &&
              (
                <span className="utility-address" data-widget-name={WIDGETS.FOOTER} data-text-color="color_4">
                  <br />
                  {translations["COPY_RIGHT_NOTE"]}
                </span>
              )
            }
            <div className="utility-phone">
              <span data-widget-name={WIDGETS.FOOTER} data-text-color="color_4">{translations["UTILITY_INFO.PHONE_NO"]}</span>
            </div>
            <div className="utility-email">
              <span data-widget-name={WIDGETS.FOOTER} data-text-color="color_4">{translations["UTILITY_INFO.EMAIL"]}</span>
            </div>
            {
              props.configs.data["showTOSlink"] == "true" ?
                (
                  <div className="utility-tos">
                    <a href={props.configs.data["termsLink_" + userLocale] ? props.configs.data["termsLink_" + userLocale] : "#"} rel="noopener noreferrer" target="_blank" onClick={() => handleClick(translations["UTILITY_INFO.TERMS_OF_SERVICE"])} data-widget-name={WIDGETS.FOOTER} data-text-color="color_1">{translations["UTILITY_INFO.TERMS_OF_SERVICE"]}</a>
                    {props.configs.data["showFaqLink"] == "true" ?
                      (
                        <a href={props.configs.data["faqLink_" + userLocale] ? updateTokenInStrings(props.configs.data["faqLink_" + userLocale]) : "#"} rel="noopener noreferrer" target="_blank"  onClick={() => handleClick(translations["UTILITY_INFO.FAQ"])} data-widget-name={WIDGETS.FOOTER} data-text-color="color_1">{translations["UTILITY_INFO.FAQ"]}</a>
                      )
                      : ''
                    }
                    {props.configs.data["showPrivacyLink"] == "true" ?
                      (
                        <a href={props.configs.data["privacyLink_" + userLocale] ? props.configs.data["privacyLink_" + userLocale] : "#"} rel="noopener noreferrer" target="_blank" onClick={() => handleClick(translations["UTILITY_INFO.PRIVACY_POLICY"])} data-widget-name={WIDGETS.FOOTER} data-text-color="color_1">{translations["UTILITY_INFO.PRIVACY_POLICY"]}</a>
                      )
                      : ''
                    }
                  </div>
                ) :
                ''
            }
          </div>
        </div>
      }
    </>
  );
}
export default withLastLocation(FooterMain);